export { default as Hidden } from './Hidden';
export type { HiddenProps } from './types';
